import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Button,
  Link,
  Autocomplete,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Breadcrumbs from "components/common/Breadcrumbs";
import Stack from "components/common/Stack";

const useStyles = makeStyles((theme) => ({
  modal: {
    textAlign: "center",
    background: "white",
    width: "200px",
    padding: "20px",
    position: "absolute",
    left: "40%",
    top: "30%",
    borderRadius: "10px",
  },
  stepLabel: {
    "& .css-hj9ocm-MuiSvgIcon-root-MuiStepIcon-root": {
      borderRadius: "50%",
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: "green",
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: "green",
    },
    "& .MuiStepLabel-label.Mui-active": {
      color: "green",
    },
    "& .MuiStepLabel-label.Mui-completed": {
      color: "green",
    },
  },
  previewButton: {
    textTransform: "none",
    color: "blue",
    borderColor: "blue",
  },
  "& .MuiStepIcon-root.MuiStepIcon-root.Mui-active": {
    color: "blue",
  },
  heading: {
    fontSize: "22px",
    marginBottom: "40px",
    display: "flex",
    alignItems: "center",
  },
  backarrowIcon: {
    fontSize: "22px",
    color: "black",
    cursor: "pointer",
    fontWeight: "bold",
    marginRight: "5px",
  },
  nextbutton: {
    textTransform: "none",
    marginRight: "15px",
  },
  ButtonBox: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
    marginLeft: "15px",
  },
  formcontrolstyle: {
    marginBottom: "20px",
  },
  Linkdiresction: {
    fontSize: "14px",
  },
  buttonBack: {
    textTransform: "none",
  },
}));

const AddVehicles = ({
  handleAddVehicle,
  subTypesData,
  vehicleDropdown,
  submitVehicle,
  vehicleData,
  menufaturerDatabyId,
  vehiclesTypeData,
  variantdropdowndata,
  GetmanufacturerId,
  modelDropdowndata,
  GetModelId,
  saveVehicleTypeId,
  saveVarientTypeId,
  varientidValue,
  
}) => {
 
  
  
 
  const handleVarientChange = (event) => {
    const { value } = event.target;
    formik.handleChange(event);
    saveVarientTypeId(value);
  };


  const handleVehiclesTypeChange = (event) => {
    const { value } = event.target;
    formik.handleChange(event);
    saveVehicleTypeId(value);
  };

  const handleManufacturerChange = (event) => {
    const { value } = event.target;
    formik.handleChange(event);
    saveManufacturerId(value);
  };

  const saveManufacturerId = (manufacturerId) => {
    GetmanufacturerId(manufacturerId);
  };

  const handlemodelChange = (event) => {
    const { value } = event.target;

    formik.handleChange(event);
    GetModelId(value);
  };

  const handleACChange = (event, value) => {
    const acIds = value.map((option) => option.id);
    const acIdsString = acIds.join(",");

    formik.setFieldValue("ac_id", acIdsString);
  };
  const handleDCChange = (event, value) => {
    const acIds = value.map((option) => option.id);
    const dcIdsString = acIds.join(",");

    formik.setFieldValue("dc_id", dcIdsString);
  };

  const years = Array.from({ length: 2024 - 1995 + 1 }, (v, k) => 1995 + k);

  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);

  const steps = ["Manufacturer", "Model", "Variant", "Connector"];

  const formik = useFormik({
    initialValues: {
      manufacturer_id: "" ?? null,
      manufacturer_name: "",
      model_id: "" ?? null,
      model_name: "",
      model_year: "",
      year: "",
      type_id: "" ?? null,
      variant_name: "",
      variant_id: '' ?? null,
      ac_id: "" ?? null,
      dc_id: "",
      sub_type:'',
      sub_type_id:''??null,
      battery_capacity:'',
    },
    

    validationSchema: Yup.object({
      manufacturer_id: Yup.string().required("Manufacturer is required"),
      manufacturer_name: Yup.string().when("manufacturer_id", {
        is: "other",
        then: Yup.string().required("Manufacturer name is required"),
      }),
      model_id: Yup.string().required("Model is required"),
      model_name: Yup.string().when("model_id", {
        is: "other",
        then: Yup.string().required("Model name is required"),
      }),
      // variant_id: Yup.string().required("Variant is required"),
      // variant_name: Yup.string().when("variant_id", {
      //   is: "other",
      //   then: Yup.string().required("Variant name is required"),
      // }),
      // sub_type: Yup.string().when("sub Type", {
      //   is: "other",
      //   then: Yup.string().required("sub Type name is required"),
      // }),
      
      ac_id: Yup.string(),
      dc_id: Yup.string(),
    }),
    onSubmit: (values) => {
      submitVehicle(values);
    },
  });

  const handleNext = () => {
    if (activeStep === 0 && formik.values.manufacturer_id) {
      if (
        formik.values.manufacturer_id !== "other" ||
        formik.values.manufacturer_name
      ) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 1 && formik.values.model_id) {
      if (formik.values.model_id !== "other" || formik.values.model_name) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 2 ) {
      // if (formik.values.variant_id == "other" || formik.values.variant_name) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      // }
    } else if (activeStep === 3 || formik.values.ac_id || formik.values.dc_id) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <>
      <Stack mt={2}>
        <Breadcrumbs
          sx={{ fontSize: "14px", color: "#0DA861" }}
          separator="›"
          aria-label="breadcrumb"
        >
          <Link
            className={classes.Linkdiresction}
            underline="hover"
            color="#A2A7AE"
            href="/vehicles"
          >
            Vehicles
          </Link>
          <Typography className={classes.Linkdiresction} color="#0DA861">
           Add vehicles
          </Typography>
        </Breadcrumbs>
      </Stack>
      <Box className={classes.center} sx={{ marginTop: "1.6rem" }}>
        <Card>
          <CardContent style={{ width: "500px" }}>
            <Typography
              className={classes.heading}
              variant="h5"
              color="#707070"
            >
              <ArrowBackIcon
                className={classes.backarrowIcon}
                onClick={() => handleAddVehicle("back")}
              />
            Add vehicles

            </Typography>
            <Stepper
              className={classes.stepLabel}
              activeStep={activeStep}
              alternativeLabel
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel className={classes.stepLabel}>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <form onSubmit={formik.handleSubmit}>
              {/* active form 0  */}
              {activeStep === 0 && (
                <Box sx={{ m: 2 }}>
                  <Typography sx={{ mb: 2 }}>Add Manufacturer</Typography>
                  {/* select vehicle type 2wheeler 3 wheeler 4wheeler */}
                  <InputLabel>Select Vehicle Type</InputLabel>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ marginBottom: "10px" }}
                    error={
                      formik.touched.type_id && Boolean(formik.errors.type_id)
                    }
                  >
                    <Select
                      name="type_id"
                      value={formik.values.type_id}
                      // onChange={formik.handleChange}
                      onChange={handleVehiclesTypeChange}
                      onBlur={formik.handleBlur}
                    >
                      {vehiclesTypeData?.map((item) => (
                        <MenuItem key={item?.name} value={item?.id}>
                          {item?.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.type_id && formik.errors.type_id && (
                      <Typography color="error">
                        {formik.errors.type_id}
                      </Typography>
                    )}
                  </FormControl>
                  {/* select vehicles type */}
                 

                 
                  {/* select manufacturer */}
                  <InputLabel>Select Manufacturer Name</InputLabel>
                  <FormControl
                    className={classes.formcontrolstyle}
                    fullWidth
                    size="small"
                    error={
                      formik.touched.manufacturer_id &&
                      Boolean(formik.errors.manufacturer_id)
                    }
                  >
                    <Select
                      name="manufacturer_id"
                      value={formik.values.manufacturer_id}
                      // onChange={formik.handleChange}
                      onChange={handleManufacturerChange}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value="other">Other</MenuItem>

                      {menufaturerDatabyId
                        ?.filter((item) => item && item.name) // Filter out null or undefined items and items without a name
                        ?.sort((a, b) => a.name.localeCompare(b.name))
                        ?.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                    {formik.touched.manufacturer_id &&
                      formik.errors.manufacturer_id && (
                        <Typography color="error">
                          {formik.errors.manufacturer_id}
                        </Typography>
                      )}
                  </FormControl>

                  {formik.values.manufacturer_id === "other" && (
                    <div>
                      <TextField
                        className={classes.formcontrolstyle}
                        size="small"
                        fullWidth
                        label="Enter manufacturer name"
                        name="manufacturer_name"
                        value={formik.values.manufacturer_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // error={
                        //   formik.touched.manufacturer_name &&
                        //   Boolean(formik.errors.manufacturer_name)
                        // }
                        // helperText={
                        //   formik.touched.manufacturer_name &&
                        //   formik.errors.manufacturer_name
                        // }
                      />

                        {
                      formik.errors.manufacturer_name && (
                        <Typography color="error" sx={{marginTop:'-20px'}}>
                          {formik.errors.manufacturer_name}
                        </Typography>
                      )}
                    </div>
                  )}
                  {/* select manufacturer year */}
                  <InputLabel>Select Manufacturer Year </InputLabel>
                  <FormControl
                    className={classes.formcontrolstyle}
                    fullWidth
                    size="small"
                    error={formik.touched.year && Boolean(formik.errors.year)}
                  >
                    <Select
                      name="year"
                      value={formik.values.year}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.year && formik.errors.year && (
                      <Typography color="error">
                        {formik.errors.year}
                      </Typography>
                    )}
                  </FormControl>
                </Box>
              )}
              {/* active form 1 */}
              {activeStep === 1 && (
                <Box sx={{ m: 2 }}>
                  <Typography sx={{ mb: 2 }}>Add Model</Typography>
                  {/* select model name  */}
                  <InputLabel>Select Model Name</InputLabel>
                  <FormControl
                    className={classes.formcontrolstyle}
                    fullWidth
                    size="small"
                    error={
                      formik.touched.model_id && Boolean(formik.errors.model_id)
                    }
                  >
                    <Select
                      name="model_id"
                      value={formik.values.model_id}
                      onChange={handlemodelChange}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value="other">Other</MenuItem>
                      {modelDropdowndata?.filter((item) => item && item.name) // Filter out null or undefined items and items without a name
                        ?.sort((a, b) => a.name.localeCompare(b.name)).map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.model_id && formik.errors.model_id && (
                      <Typography color="error">
                        {formik.errors.model_id}
                      </Typography>
                    )}
                  </FormControl>
                  {formik.values.model_id === "other" && (
                    <FormControl fullWidth>
                      <TextField
                        className={classes.formcontrolstyle}
                        fullWidth
                        size="small"
                        label="Enter vehicle model name"
                        name="model_name"
                        value={formik.values.model_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // error={
                        //   formik.touched.model_name &&
                        //   Boolean(formik.errors.model_name)
                        // }
                        // helperText={
                        //   formik.touched.model_name && formik.errors.model_name
                        // }
                      />
                        {
                      formik.errors.model_name && (
                        <Typography color="error" sx={{marginTop:'-20px'}}>
                          {formik.errors.model_name}
                        </Typography>
                      )}
                    </FormControl>
                  )}
                </Box>
              )}
              {/* active form 2 */}
              {activeStep === 2 && (
                <Box sx={{ m: 3 }}>
                  <Typography sx={{ mb: 2 }}>Add Variant</Typography>
                  {/* Select variant name  */}
                  <InputLabel>Select Variant Name</InputLabel>
                  <FormControl
                    className={classes.formcontrolstyle}
                    fullWidth
                    size="small"
                    error={
                      formik.touched.variant_id &&
                      Boolean(formik.errors.variant_id)
                    }
                  >
                    <Select
                      name="variant_id"
                      value={formik.values.variant_id}
                      onChange={handleVarientChange}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value="other">Other</MenuItem>
                      {variantdropdowndata
                        // ?.filter((item) => item && item.name) // Filter out null or undefined items and items without a name
                        // ?.sort((a, b) => a.name.localeCompare(b.name))
                        ?.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                    {formik.touched.variant_id && formik.errors.variant_id && (
                      <Typography color="error">
                        {formik.errors.variant_id}
                      </Typography>
                    )}
                  </FormControl>
                  {formik.values.variant_id === "other" && (
                    <FormControl fullWidth>
                      <TextField
                        className={classes.formcontrolstyle}
                        fullWidth
                        size="small"
                        label="Enter variant name"
                        name="variant_name"
                        value={formik.values.variant_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // error={
                        //   formik.touched.variant_name &&
                        //   Boolean(formik.errors.variant_name)
                        // }
                        // helperText={
                        //   formik.touched.variant_name &&
                        //   formik.errors.variant_name
                        // }
                      />
                      {/* {
                      formik.errors.variant_name && (
                        <Typography color="error" sx={{marginTop:'-20px'}}>
                          {formik.errors.variant_name}
                        </Typography>
                      )} */}
                    </FormControl>
                  )}
                   {formik.values.variant_id === "other" && (
                    <FormControl fullWidth>
                      <TextField
                        className={classes.formcontrolstyle}
                        fullWidth
                        size="small"
                        label="Enter Battery Capacity name"
                        name="battery_capacity"
                        value={formik.values.battery_capacity}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // error={
                        //   formik.touched.variant_name &&
                        //   Boolean(formik.errors.variant_name)
                        // }
                        // helperText={
                        //   formik.touched.variant_name &&
                        //   formik.errors.variant_name
                        // }
                      />
                      {/* {
                      formik.errors.variant_name && (
                        <Typography color="error" sx={{marginTop:'-20px'}}>
                          {formik.errors.variant_name}
                        </Typography>
                      )} */}
                    </FormControl>
                  )}
                  
                  {/* Select variant name  */}
                  {/* <InputLabel>Select Sub Types </InputLabel> */}
                  {/* <FormControl
                    className={classes.formcontrolstyle}
                    fullWidth
                    size="small"
                    error={
                      formik.touched.sub_type_id &&
                      Boolean(formik.errors.sub_type_id)
                    }
                  >
                    <Select
                      name="sub_type_id"
                      value={formik.values.sub_type_id}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value="other">Other</MenuItem>
                      {subTypesData?.filter((item) => item && item.sub_type) // Filter out null or undefined items and items without a name
                        ?.sort((a, b) => a.sub_type.localeCompare(b.sub_type))
                        ?.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.sub_type
                            }
                          </MenuItem>
                        ))}
                    </Select>
                    {formik.touched.variant_id && formik.errors.variant_id && (
                      <Typography color="error">
                        {formik.errors.variant_id}
                      </Typography>
                    )}
                  </FormControl> */}
                  {/* {formik.values.sub_type_id === "other" && (
                    <FormControl fullWidth>
                      <TextField
                        className={classes.formcontrolstyle}
                        fullWidth
                        size="small"
                        label="Enter sub type name"
                        name="sub_type"
                        value={formik.values.sub_type}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // error={
                        //   formik.touched.sub_type &&
                        //   Boolean(formik.errors.sub_type)
                        // }
                        // helperText={
                        //   formik.touched.sub_type &&
                        //   formik.errors.sub_type
                        // }
                      />
                      {
                      formik.errors.sub_type && (
                        <Typography color="error" sx={{marginTop:'-20px'}}>
                          {formik.errors.sub_type}
                        </Typography>
                      )}
                    </FormControl>
                  )} */}
{/* 
                  <TextField
                    className={classes.formcontrolstyle}
                    fullWidth
                    size="small"
                    label="Enter Battery Capacity (Kwh)"
                    name="battery_capacity"
                    value={formik.values.battery_capacity}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        formik.setFieldValue("battery_capacity", value);
                      }
                    }}
                    onBlur={formik.handleBlur}
                  /> */}
                  </Box>
              )}
              {/* active form 3 */}
              {activeStep === 3 && (
                <Box sx={{ m: 3 }}>
                  <Typography sx={{ mb: 2 }}>Connector</Typography>
                  {/* select multiple ac connector  */}
                  <InputLabel>Select AC Connector</InputLabel>
                  <Autocomplete
                    className={classes.formcontrolstyle}
                    multiple
                    id="tags-outlined"
                    options={(vehicleDropdown?.acTypes || []).sort((a, b) => a.name.localeCompare(b.name))}
                    getOptionLabel={(option) => option.name}
                    filterSelectedOptions
                    onChange={handleACChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="AC Connector"
                        placeholder="Select Ac"
                        size="small"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    )}
                  />
                  {/* select multiple dc connector  */}
                  <InputLabel> Select DC Connector</InputLabel>
                  <FormControl
                    className={classes.formcontrolstyle}
                    fullWidth
                    size="small"
                    error={formik.touched.dc_id && Boolean(formik.errors.dc_id)}
                  >
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      options={(vehicleDropdown?.dcTypes || []).sort((a, b) => a.name.localeCompare(b.name))}
                      getOptionLabel={(option) => option.name}
                      filterSelectedOptions
                      onChange={handleDCChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="DC Connector"
                          placeholder="Select Dc"
                          size="small"
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                          {option.name}
                        </li>
                      )}
                    />
                    {formik.touched.dc_id && formik.errors.dc_id && (
                      <Typography color="error">
                        {formik.errors.dc_id}
                      </Typography>
                    )}
                  </FormControl>
                </Box>
              )}
              {/* next and submit handle  */}
              <Box className={classes.ButtonBox}>
                {activeStep !== 0 && (
                  <Button
                    className={classes.buttonBack}
                    variant="outlined"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                )}
                {activeStep === steps.length - 1 ? (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonBack}
                    type="submit"
                    disabled={
                      activeStep === 3 && formik.values.ac_id
                        ? !formik.values.ac_id
                        : !formik.values.dc_id
                    }
                  >
                    Add Vehicle
                  </Button>
                ) : (
                  <Button
                    className={classes.nextbutton}
                    variant="contained"
                    color="primary"
                    disabled={
                      (activeStep === 0 &&
                        (!formik.values.manufacturer_id ||
                          !formik.values.year)) ||
                      (activeStep === 1 && !formik.values.model_id) ||
                      (activeStep === 3 &&
                        (!formik.values.ac_id || !formik.values.dc_id))
                    }
                    onClick={handleNext}
                  >
                    Next
                  </Button>
                )}
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default AddVehicles;
